<template>
  <div class="report-content">
    <!-- Filters Section -->
    <div class="filter-block">
      <div class="single-row">
      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateComputed"
                            label="Date Range"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            hide-details
                            outlined
                            dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="dateRange"
                          color="black"
     :max="startMax"
                          range
                      ></v-date-picker>
                    </v-menu>
      </div>

      <div class="filter-items">
        <v-autocomplete v-model="status" :items="statusList" label="Trip Status" placeholder="Trip Status" item-text="name" item-value="id" outlined dense hide-details clearable ></v-autocomplete>
      </div>

      <div class="filter-items">
        <v-autocomplete v-model="crewType" :items="crewTypes" placeholder="Crew Type" label="Crew Type" item-text="name" item-value="id" outlined dense hide-details clearable></v-autocomplete>
      </div>

      <div class="filter-items">
        <v-autocomplete v-model="responsibilityType" :items="types" placeholder="Responsibility Type" label="Responsibility Type" item-text="name" item-value="id" outlined dense hide-details clearable></v-autocomplete>
      </div>

      <div class="filter-items filter-button">
        <v-btn color="#ff9600" class="white--text" @click="getReport">Generate Report</v-btn>
      </div>
     <div v-if="report.length" class="filter-items filter-button">
             <v-btn color="#18921d" @click="downloadReport" medium
        ><span style="color: white;">Download</span> 
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="20px" viewBox="0 0 24 24" width="20px" fill="#ffffff">
          <g><rect fill="none" height="24" width="24" /></g>
          <g><path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z" /></g>
        </svg>
      </v-btn>
      </div>
    </div>
    
<div v-if="report.length" style="display: flex; justify-content: flex-end; padding: 10px 20px 0px 0px;">
  <span>Total - {{ totalRows }}</span>
</div>
 

    <!-- Table Section -->
    <div class="table-wrapper">
    <template v-if="report.length">
    <v-data-table
      :headers="headers"
      :items="report"
      class="op-table"
      fixed-header
      hide-default-footer
      :items-per-page="limit"
      :page="page"
    >
      <!-- <template v-slot:item.reportingTime="{ item }">
        {{ formatDate(item.reportingTime) }}
      </template>
      <template v-slot:item.dropOffTime="{ item }">
        {{ formatDate(item.dropOffTime) }}
      </template>

      <template v-slot:item.cancellationDate="{ item }">
        {{ formatDate(item.cancellationDate) }}
      </template> -->
    </v-data-table>
  </template>

  <template v-else>
    <div class="no-data-text">No data available</div>
  </template>

  <!-- Pagination -->
  <div class="pagination-container" v-if="report.length">
    <v-pagination
      v-model="page"
      circle
      :total-visible="7"
      :length="Math.ceil(totalRows / limit)"
      @input="handlePageChange"
      prev-icon="mdi-menu-left"
      next-icon="mdi-menu-right"
    ></v-pagination>
     <div v-if="loading" class="loader-overlay">
  <v-progress-circular
    :width="5"
    :size="50"
    color="red"
    indeterminate
  ></v-progress-circular>
</div>

  </div>
    </div>
  </div>
</template>

<script>
import moment, { max } from "moment";
import axios from '../../axios/axios-global'
    import VueExcel from "@/components/common/VueExcel";
export default {
  name: "OperationalReport",
    data() {
      const startPoint = moment("2025-10-05");
    return {
      startDate: new Date().toISOString().split("T")[0],
      startDateModal: false,
        state: null,
      menu1:false,
        branch: null,
      limit: 20,
      responsibilityType: -1,
      minDate: moment().subtract(60, 'days').format('YYYY-MM-DD'),
      startMax: startPoint.format("YYYY-MM-DD"),
      dateRange: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      today: moment().format("YYYY-MM-DD"),
      startMax: moment().format("YYYY-MM-DD"),
      statusList: [
        //    SP Assigned [2]
        // Driver Assigned [4]
        // On the way [5]
        // Arrived [6]
        // Driver Started [7, 8]
        // Driver Ended [9, 10]
        // Cancelled [11,12,13,14,15]

        { id: 2, name: "SP Assigned" },
        { id: 4, name: "Driver Assigned" },
        { id: 5, name: "On the way" },
        { id: 6, name: "Arrived" },
        { id: 7, name: "Driver Started" },
        { id: 8, name: "Driver Ended" },
        { id: 9, name: "Cancelled" },
      ],
      status: -1,
      branches: [
        { id: 1, name: "Branch A" },
        { id: 2, name: "Branch B" },
        { id: 3, name: "Branch C" }
      ],
      crewTypes: [
        { name: "CP", enabled: false, value: "CP" },
        { name: "FO", enabled: false, value: "FO" },
        { name: "LD", enabled: false, value: "LD" },
        { name: "CA", enabled: false, value: "CA" },
      ],
      types: [
        { id: 1, name: "PickUp" },
        { id: 2, name: "DropOff" },
      ],
      headersText: [
        // { text: "Trip ID", value: "tripId" },
        // { text: "Hotac Booking ID", value: "hotacBookingId" },
        // { text: "Crew ID", value: "crewId" },
        // { text: "Crew Name", value: "crewName" },
        // { text: "Crew Mobile", value: "crewPhone" },
        // { text: "Crew Category", value: "crewCategory" },

        // { text: "Drop Off Time", value: "dropOffTime" },
        // { text: "Reporting Time", value: "reportingTime" },
        //     { text: "Gender", value: "gender" },
        // { text: "Transporter Name", value: "transporterName" },
       { text: "Responsibility Type", value: "responsibilityType" },
        { "text": "Booking  Date", "value": "bookingDate", "sortable": false },
      { text: "Station", value: "station" },
      { text: "Pick Up Address", value: "pickUpAddress" },
        { text: "Drop Off Address", value: "dropOffAddress" },
        { text: "Status", value: "bookingStatus" },
        { text: "Driver Name", value: "driverName" },
        { text: "Driver Mobile", value: "driverMobile" },
        { text: "Cab No", value: "cabNo" },
        { text: "Cancellation Date", value: "cancellationDate" },

      ],
      headers: [],
        loading:false,
        totalRows:0,
//   tripId: 1760550755466312,
//           hotacBookingId: 24740589,
//           crewId: '64517',
//           crewName: 'Akani Awomi',
//           crewPhone: '6360343917',
//           crewCategory: 'LD',
//           dropOffTime: '2025-10-16T23:00:00',
//           reportingTime: '2025-10-16T23:20:00',
//           transporterName: 'MALIKTRANSPORTBLR',
//           station: 'BLR',
//           pickUpAddress: 'T1, BLR Airport',
//           dropOffAddress: 
//             'House no-10, first floor, king street, Kammanahalli circle, near Empire Restaurant. Bangalore  560084',
//           flightInfo: 'Flight No:6E285 arriving on 2025-10-16 22:50 at BLR from HYD',
//           bookingStatus: 'Service Partner Assigned',
//           responsibilityType: 'DropOff',
//           clubbedCrewTripId: '',
//           cancellationDate: null

      crewType:'',
        trips: [
        //     { tripid: "T001", hotacbookingid: "HB001", crewid: "C001", crewname: "John Doe", crewmobile: "9876543210", crewcategory: "A", DropOffTime: "10:30 AM", ReportingTime: "10:30 AM", TransporterName: "Transporter Name", Station: "Station Name", PickUpAddress: "Pick Up Address", DropOffAddress: "Drop Off Address", FlightInfo: "Flight Info", BookingStatus: "Booking Status", TripType: "Trip Type", CabNo: "Cab No", ClubbedTripID: "Clubbed Trip ID", CancellationDate: "Cancellation Date" },
        // { tripid: "T002", hotacbookingid: "HB002", crewid: "C002", crewname: "Jane Smith", crewmobile: "9876543211", crewcategory: "B", DropOffTime: "11:00 AM", ReportingTime: "11:00 AM", TransporterName: "Transporter Name", Station: "Station Name", PickUpAddress: "Pick Up Address", DropOffAddress: "Drop Off Address", FlightInfo: "Flight Info", BookingStatus: "Booking Status", TripType: "Trip Type", CabNo: "Cab No", ClubbedTripID: "Clubbed Trip ID", CancellationDate: "Cancellation Date" },
        ],
        page: 1,
      report:[],
      itemsPerPage: 10,
      downloadable:""
    };
    },
    watch: {
 dateRange() {
            if (this.dateRange[0]) {
              if (this.dateRange[1]) {
                if (this.dateRange[0] > this.dateRange[1]) {
                  this.startDate = moment(this.dateRange[1]).format('YYYY-MM-DD')
                  this.endDate = moment(this.dateRange[0]).format('YYYY-MM-DD')
                } else {
                  this.startDate = moment(this.dateRange[0]).format('YYYY-MM-DD')
                  this.endDate = moment(this.dateRange[1]).format('YYYY-MM-DD')
                }
                //  this.getReport()
                this.menu1 = false
              }
               
        }
          
      },
//       responsibilityType()
//       {
//         this.getReport()
//       },
//       crewType()
//       {
// this.getReport()
//       },
      
//       status()
//       {
// this.getReport()
//       },
          

          
    },
    computed: {
     dateComputed() {
            let start = ''
            let end = ''
            if (this.dateRange[0] > this.dateRange[1]) {
              start = moment(this.dateRange[1]).format('MMM DD')
              end = moment(this.dateRange[0]).format('MMM DD')
            } else {
              start = moment(this.dateRange[0]).format('MMM DD')
              end = moment(this.dateRange[1]).format('MMM DD')
            }
            return `${start} ~ ${end}`
          },

  },
  methods: {
    async downloadReport() {
  this.loading=true
  let statuses = -1;

  if (this.status !== -1 && this.status !== null) {
    if (this.status === 7) {
      statuses = [7, 8];
    } else if (this.status === 8) {
      statuses = [9, 10];
    } else if (this.status === 9) {
      statuses = [11, 12, 13, 14, 15];
    } else {
      statuses = [this.status];
    }
  }

  try {
    
    const payload = {
      startDate: this.startDate,
      endDate: this.endDate,
      page: this.page,
      limit: this.limit,
      status: statuses,
      serviceType: this.responsibilityType ? this.responsibilityType : -1,
      crewCategory: this.crewType ? this.crewType : "",
      isExport: true,
    };


    const response = await axios.post('/report/indigo/ops-report', payload);
    const report = response.data.report || [];
    if (response.data.status === 200)
    {
      this.loading=false
    }

    if (report.length === 0) {
      this.$toasted.show('No report data available for the selected filters.', {
        position: "bottom-center",
        duration: 4000
      });
      return;
    }
    const headerText = [
      { text: "Responsibility Type", value: "responsibilityType" },
       { "text": "Booking  Date", "value": "bookingDate", "sortable": false },
      { text: "Station", value: "station" },
      { text: "Pick Up Address", value: "pickUpAddress" },
        { text: "Drop Off Address", value: "dropOffAddress" },
        { text: "Status", value: "bookingStatus" },
        { text: "Driver Name", value: "driverName" },
        { text: "Driver Mobile", value: "driverMobile" },
        { text: "Cab No", value: "cabNo" },
        { text: "Cancellation Date", value: "cancellationDate" },
    ];

 const maxLength = Math.max(...report.map((item) => item.employees.length));
 const employeeHeaders = this.setHeaders(maxLength);
 const headers = [...employeeHeaders, ...headerText]
 headers.unshift({ text: "Trip ID", value: "tripId", sortable: false });
 const reportDataItems = this.formatTripsForTable(report);
 const formattedReport = reportDataItems.map(item => ({
 ...item, 
 }));
    const reportData = [
      headers.map(h => h.text), 
      ...formattedReport.map(item =>
        headers.map(h => (item[h.value] != null ? item[h.value] : ""))
      ),
    ];
    console.log(reportData,"reportData")
    this.downloadable= [...reportData]
    VueExcel.methods.downloadExcelSheet(reportData, `Operational_Report ${this.startDate} - ${this.endDate}`, { skipHeader: true });
    this.$toasted.show('Report Downloaded', {
      position: "bottom-center", 
      type: "success",
      duration: 4000
    })

  } catch (error) {
    console.error("Error downloading report:", error);
  }
},

    


        formatDate(date)
        {
        if (!date) return '';
    return moment(date).format('MMM DD, HH:mm'); 
    },
    handlePageChange(newPage) {
          this.page = newPage;
          this.getReport()
    },
   
    async getReport() {
        this.loading=true
        let statuses=-1
          if (this.status !== -1 && this.status !== null) {
  if (this.status === 7) {
    statuses = [7, 8];
  } else if (this.status === 8) {
    statuses = [9, 10];
  } else if (this.status === 9) {
    statuses = [11, 12, 13, 14, 15];
  } else {
    statuses = [this.status];
  }
}
       try {
           const payload = {
               startDate: this.startDate,
               endDate: this.endDate,
               page: this.page,
               limit: this.limit,
               status: statuses,
                 serviceType: this.responsibilityType ? this.responsibilityType : -1,
               crewCategory: this.crewType ? this.crewType : "", 
               isExport:false,
           }
        console.log(payload)
           const response = await axios.post('/report/indigo/ops-report', payload)
           console.log(response, "___")
        if( response.data.status === 200 )
         {
            this.report = response.data.report
         this.totalRows = response.data.rowCount
        const maxLength = Math.max(...this.report.map((item) => item.employees.length));
        const employeeHeaders = this.setHeaders(maxLength);
        this.headers = this.headersText;
        this.headers = [...employeeHeaders, ...this.headers];
        this.headers.unshift({ text: "Trip ID", value: "tripId", sortable: false });
        this.report = this.formatTripsForTable(this.report);
        console.log(this.report,"report")
        this.loading=false
       }
       } catch (error) {
      this.loading=false
        console.log(error)
     }
    },

    setHeaders(maxLength) {
       const baseHeaders = [
        { text: "Hotac Booking ID", value: "hotacBookingId" },
        { text: "Crew ID", value: "crewId" },
        { text: "Crew Name", value: "crewName" },
        { text: "Gender", value: "gender" },
        { text: "Crew Mobile", value: "crewPhone" },
        { text: "Crew Category", value: "crewCategory" },
        { text: "Address", value: "address", sortable: false },
        { text: "Drop Off Time", value: "dropOffTime" },
        { text: "Reporting Time", value: "reportingTime" },
        { text: "Flight Info", value: "flightInfo", sortable: false },
        { text: "Booking Status", value: "hotacStatus", sortable: false },
        ];
        const employeeHeaders = [];
            for (let i = 0; i < maxLength; i++) {
            baseHeaders.forEach((h) => {
            employeeHeaders.push({
            text: `Employee${i + 1} ${h.text}`,
            value: `emp_${i + 1}_${h.value}`,
            sortable: h.sortable,
           });
         });
         }
         return employeeHeaders;
    },
    formatTripsForTable(trips) {
      return trips.map((trip) => {
        const formatted = { ...trip };

        trip.employees.forEach((emp, i) => {
          Object.keys(emp).forEach((key) => {
            formatted[`emp_${i + 1}_${key}`] = emp[key];
          });
        });

        return formatted;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.report-content {
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  background: #f5f5f5;

  .filter-block {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    background: white;
    border-bottom: 1px solid #e0e0e0;
    align-items: center;

    .filter-items {
      min-width: 200px;
      flex: 0 1 auto;

      ::v-deep .v-text-field__slot input {
        font-size: 0.9rem;
      }
    }

    .filter-button {
      min-width: auto;

      ::v-deep .v-btn {
        font-size: 0.9rem;
      }

     
    }
       .single-row {
      ::v-deep .v-btn {
        color: white;
      }

    }
  }

  .table-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: white;
    margin: 15px;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
.no-data-text {
  padding: 50px;
  text-align: center;
  font-size: 16px;
  color: #888;
  width: 100%;
}

    .op-table {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      ::v-deep .v-data-table {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      ::v-deep .v-data-table__wrapper {
        flex: 1;
        overflow-y: auto;
        overflow-x: auto;
      }

      ::v-deep .v-data-table-header {
        background: #f5f5f5;
        flex-shrink: 0;
        border-bottom: 2px solid #e0e0e0;
        position: sticky;
        top: 0;
        z-index: 5;
     
      }

      ::v-deep tbody tr {
        height: auto;
           border-bottom: 1px solid #b8b8b8;
      transition: background-color 0.2s ease;
     
        td {
          padding: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
           border-right: 1px solid #b8b8b8;

     
          
        //   max-width: 200px;
        }
      }
::v-deep tbody tr:last-child td {
  border-bottom: 1px solid #b8b8b8;

}

      ::v-deep th {
        white-space: nowrap;
        padding: 0px 20px 0 20px;
        min-width: 150px;
          background-color: rgba(255, 255, 255, 0.863);
          color: #6a0737;
              border-right: 1px solid #b8b8b8;
        font-size: 15px;
        font-weight: 800 !important;
          &:last-child {
        border-right: none;
 
      }
      }
    }

    .pagination-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      background: white;
      border-top: 1px solid #e0e0e0;

      ::v-deep .v-pagination {
        justify-content: center;
      }
    }
    .loader-overlay {
  position: fixed;      
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.7); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;       
}

  }
}
</style>